export const actionTypes = {
    MODAL_OPEN: 'MODAL_OPEN',
    MODAL_CLOSE: 'MODAL_CLOSE',
    NOTIFICATION_LOADING_START: 'NOTIFICATION_LOADING_START',
    NOTIFICATION_LOADING_END: 'NOTIFICATION_LOADING_END',
    SAGA_FETCH_PUSH_NOTIFICATION_BY_ID: 'SAGA_FETCH_PUSH_NOTIFICATION_BY_ID',
    SAGA_UPDATE_PUSH_NOTIFICATION: 'SAGA_UPDATE_PUSH_NOTIFICATION',
    FETCH_PUSH_NOTIFICATION_BY_ID_SUCCESS: 'FETCH_PUSH_NOTIFICATION_BY_ID_SUCCESS',
    FETCH_PUSH_NOTIFICATION_BY_ID_FAILED: 'FETCH_PUSH_NOTIFICATION_BY_ID_FAILED',
    FETCH_ALL_PUSH_NOTIFICATIONS_SUCCESS: 'FETCH_ALL_PUSH_NOTIFICATIONS_SUCCESS',
    PUSH_NOTIFICATIONS_ERROR: 'PUSH_NOTIFICATIONS_ERROR',
    SAGA_FETCH_PUSH_NOTIFICATIONS: 'SAGA_FETCH_PUSH_NOTIFICATIONS',
    SAGA_CREATE_PUSH_NOTIFICATION: 'SAGA_CREATE_PUSH_NOTIFICATION',
    CREATE_PUSH_NOTIFICATION_SUCCESS: 'CREATE_PUSH_NOTIFICATION_SUCCESS',
    UPDATE_PUSH_NOTIFICATION_SUCCESS: 'UPDATE_PUSH_NOTIFICATION_SUCCESS',
    UPDATE_PUSH_NOTIFICATION_TITLE_SUCCESS: 'UPDATE_PUSH_NOTIFICATION_TITLE_SUCCESS',
    DISPLAY_UPDATE_SUCCESS_ALERT: 'DISPLAY_UPDATE_SUCCESS_ALERT',
    CLEAR_UPDATE_SUCCESS_ALERT: 'CLEAR_UPDATE_SUCCESS_ALERT',
    SAGA_UPDATE_PUSH_NOTIFICATION_TITLE: 'SAGA_UPDATE_PUSH_NOTIFICATION_TITLE',
    SAGA_DELETE_PUSH_NOTIFICATION: 'SAGA_DELETE_PUSH_NOTIFICATION',
    SAGA_PUBLISH_PUSH_NOTIFICATION: 'SAGA_PUBLISH_PUSH_NOTIFICATION',
    SAGA_UN_PUBLISH_PUSH_NOTIFICATION: 'SAGA_UN_PUBLISH_PUSH_NOTIFICATION',
    SAGA_FETCH_DMA_LIST: 'SAGA_FETCH_DMA_LIST',
    FETCH_DMA_LIST_SUCCESS: 'FETCH_DMA_LIST_SUCCESS',

    /** Notification Filter action types */
    UPDATE_NOTIFICATIONS_FILTER: 'UPDATE_NOTIFICATIONS_FILTER',
    CLEAR_NOTIFICATIONS_FILTER: 'CLEAR_NOTIFICATIONS_FILTER',

    /** Notification Users action types */
    SAGA_FETCH_NOTIFICATION_USERS: 'SAGA_FETCH_NOTIFICATION_USERS',
    USER_LOADING_START: 'USER_LOADING_START',
    USER_LOADING_END: 'USER_LOADING_END',
    TOGGLE_EDIT_TITLE_MODAL: 'TOGGLE_EDIT_TITLE_MODAL',
}

export const sagaFetchNotificationUsers = () => ({
    type: actionTypes.SAGA_FETCH_NOTIFICATION_USERS,
})

export const updateNotificationsFilter = payload => ({
    type: actionTypes.UPDATE_NOTIFICATIONS_FILTER,
    payload,
})

export const clearNotificationsFilter = () => ({
    type: actionTypes.CLEAR_NOTIFICATIONS_FILTER,
})

export const userLoadingStart = () => ({
    type: actionTypes.USER_LOADING_START,
})

export const userLoadingEnd = () => ({
    type: actionTypes.USER_LOADING_End,
})

export const modalOpen = () => ({
    type: actionTypes.MODAL_OPEN,
})

export const clearUpdateSuccessAlert = () => ({
    type: actionTypes.CLEAR_UPDATE_SUCCESS_ALERT,
})

export const modalClose = () => ({
    type: actionTypes.MODAL_CLOSE,
})

export const sagasFetchPushNotificationByID = payload => ({
    type: actionTypes.SAGA_FETCH_PUSH_NOTIFICATION_BY_ID,
    payload,
})

export const sagaUpdatePushNotification = notification => ({
    type: actionTypes.SAGA_UPDATE_PUSH_NOTIFICATION,
    payload: notification,
})

export const notificationLoadingStart = () => ({
    type: actionTypes.NOTIFICATION_LOADING_START,
})

export const notificationLoadingEnd = () => ({
    type: actionTypes.NOTIFICATION_LOADING_END,
})

export const fetchPushNotificationByIdSuccess = payload => ({
    type: actionTypes.FETCH_PUSH_NOTIFICATION_BY_ID_SUCCESS,
    payload,
})

export const fetchPushNotificationByIdFailed = () => ({
    type: actionTypes.FETCH_PUSH_NOTIFICATION_BY_ID_FAILED,
})

export const updatePushNotificationSuccess = payload => ({
    type: actionTypes.UPDATE_PUSH_NOTIFICATION_SUCCESS,
    payload,
})

export const updatePushNotificationTitleSuccess = payload => ({
    type: actionTypes.UPDATE_PUSH_NOTIFICATION_TITLE_SUCCESS,
    payload,
})

export const fetchPushNotifications = data => ({
    type: actionTypes.SAGA_FETCH_PUSH_NOTIFICATIONS,
    payload: data,
})

export const fetchPushNotificationsListSuccess = payload => ({
    type: actionTypes.FETCH_ALL_PUSH_NOTIFICATIONS_SUCCESS,
    payload: payload,
})

export const setPushNotificationsError = payload => ({
    type: actionTypes.PUSH_NOTIFICATIONS_ERROR,
    payload,
})

export const createPushNotification = payload => ({
    type: actionTypes.SAGA_CREATE_PUSH_NOTIFICATION,
    payload,
})

export const createPushNotificationSuccess = payload => ({
    type: actionTypes.CREATE_PUSH_NOTIFICATION_SUCCESS,
    payload,
})

export const sagaDeletePushNotification = payload => ({
    type: actionTypes.SAGA_DELETE_PUSH_NOTIFICATION,
    payload,
})

export const sagaPublishPushNotification = payload => ({
    type: actionTypes.SAGA_PUBLISH_PUSH_NOTIFICATION,
    payload,
})

export const sagaUnPublishPushNotification = payload => ({
    type: actionTypes.SAGA_UN_PUBLISH_PUSH_NOTIFICATION,
    payload,
})

export const sagaUpdatePushNotificationTitle = (title, localizations) => ({
    type: actionTypes.SAGA_UPDATE_PUSH_NOTIFICATION_TITLE,
    payload: { title, localizations },
})

export const displayUpdateSuccesAlert = payload => ({
    type: actionTypes.DISPLAY_UPDATE_SUCCESS_ALERT,
    payload,
})

export const toggleEditTitleModal = () => ({
    type: actionTypes.TOGGLE_EDIT_TITLE_MODAL,
})

export const sagaFetchDMAList = () => ({
    type: actionTypes.SAGA_FETCH_DMA_LIST,
})

export const fetchDMAListSuccess = payload => ({
    type: actionTypes.FETCH_DMA_LIST_SUCCESS,
    payload,
})
